import { slice } from "../../Utils/stringUtils";
import AnimatedPage from "../AnimatedPage/AnimatedPage";
import Button from "../_widgets/Button/Button";
import NavBar from "../_widgets/NavBar/NavBar";
import Text from "../_widgets/Text/Text";
import CustomTooltip from "../_widgets/Tooltip/CustomTooltip";
import "./style.scss";
const BeforeAfterUi = ({
  hospitalData,
  beforeImage,
  setBeforeImage,
  afterImage,
  setAfterImage,
  handleImageChange,
  downloadPoster,
  posterRef,
}) => {
  return (
    <AnimatedPage>
      <NavBar
        heading="Before & After"
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        Icon="menu"
      />
      <div className="patient_list white_card">
        <div className="before-after-container" ref={posterRef}>
          <CustomTooltip text={hospitalData?.name} placement="top">
            <Text type="h4" text={slice(hospitalData?.name, 50)} className="hospital-name" />
          </CustomTooltip>
          <div className="top-right-chevron-stack">
            <div className="chevron blue-bottom"></div>
            <div className="chevron black-middle"></div>
            <div className="chevron blue-top"></div>
          </div>

          <div className="image-section">
            <div className="image-box">
              {beforeImage ? (
                <>
                  <img src={beforeImage} alt="Before" />
                  <button
                    className="remove-btn hide-on-capture"
                    onClick={() => setBeforeImage(null)}
                    type="button"
                    aria-label="Remove before image"
                  >
                    ✕
                  </button>
                </>
              ) : (
                <>
                  <input
                    id="before-upload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => handleImageChange(e, setBeforeImage)}
                    accept="image/*"
                  />
                  <label htmlFor="before-upload">
                    Upload Before Image <br /> 300 * 300
                  </label>
                </>
              )}
              <div className="tag">BEFORE</div>
            </div>

            <div className="image-box">
              {afterImage ? (
                <>
                  <img src={afterImage} alt="After" />
                  <button
                    className="remove-btn hide-on-capture"
                    onClick={() => setAfterImage(null)}
                    type="button"
                  >
                    ✕
                  </button>
                </>
              ) : (
                <>
                  <input
                    id="after-upload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => handleImageChange(e, setAfterImage)}
                    accept="image/*"
                  />
                  <label htmlFor="after-upload">
                    Upload After Image <br /> 300 * 300
                  </label>
                </>
              )}
              <div className="tag">AFTER</div>
            </div>
          </div>

          <div className="hospital-info">
            <p>{hospitalData?.address}</p>
            <p>{hospitalData?.mno}</p>
          </div>

          <div className="bottom-left-bar"></div>
          <div className="bottom-left-corner"></div>
          <div className="bottom-right-dot-wrapper">
            {Array.from({ length: 100 }).map((_, i) => (
              <span className="dot" key={i} />
            ))}
          </div>
        </div>
        <div className="download-button hide-on-capture">
          <Button text={"  Download Poster"} buttonType="primary" onClick={downloadPoster} />
        </div>
      </div>
    </AnimatedPage>
  );
};
export default BeforeAfterUi;
